// src/seoRouteMap.js

export const SEO_ROUTE_MAP = {
  "/": "Menu",
  "/giftvoucher": "Gift Voucher",
  "/contact-us": "Contact Us",
  "/reservation": "Reservation",
  "/events": "Events",
  "/about-us": "About",
  "/thank-you": "Thanks",
};
